export const VEHICLE_REGISTRATION_FAQ_ROUTE = 'pytania-i-opowiedzi';
